"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const cache_1 = __importDefault(require("./cache"));
const countries_1 = __importDefault(require("./countries"));
const Row_1 = __importDefault(require("./Row"));
const StyledList_1 = __importDefault(require("./StyledList"));
const List = ({ onChangeCountry, value, flagsHost }) => {
    return ((0, jsx_runtime_1.jsx)(StyledList_1.default, { width: 280, height: 239, rowHeight: 38, deferredMeasurementCache: cache_1.default, rowCount: countries_1.default.length, rowRenderer: ({ key, index, parent, style, ...rest }) => ((0, jsx_runtime_1.jsx)(Row_1.default, { index: index, parent: parent, style: style, onSelect: onChangeCountry, selectedAlphaCode2: value.alphaCode2, flagsHost: flagsHost, ...rest }, key)) }));
};
exports.default = List;
//# sourceMappingURL=index.js.map